module.exports = __webpack_public_path__ + "img/offhours.2f31ae37.png";